import React from "react";
import { Modal, Button } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Unified delete/deactivate confirmation modal
 * @param {Object} props
 * @param {boolean} props.show - Whether modal is visible
 * @param {Function} props.onHide - Callback to hide the modal
 * @param {Function} props.onConfirm - Callback when user confirms action
 * @param {string} props.itemName - Name of the item being deleted/deactivated
 * @param {string} props.message - Custom message to display (optional)
 * @param {string} props.title - Modal title (optional, defaults based on variant)
 * @param {string} props.variant - "delete" or "deactivate" (default: "delete")
 * @param {string} props.confirmText - Custom confirm button text (optional)
 */
const DeleteConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  itemName,
  message,
  title,
  variant = "delete",
  confirmText,
  loading = false,
}) => {
  const isDelete = variant === "delete";

  const defaultTitle = isDelete ? "Delete File" : "Deactivation Confirmation";
  const defaultMessage = isDelete
    ? `Are you sure you want to delete the file ${itemName}?`
    : `Are you sure you want to deactivate ${itemName}?`;
  const defaultConfirmText = isDelete ? "Delete" : "Deactivate";
  const iconSrc = isDelete
    ? "../assets/img/reports/delete-popup.svg"
    : "assets/img/deactivate.png";
  const iconSize = isDelete ? { width: "30px", height: "30px" } : { width: "55px", height: "55px" };

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="custom-modal-width-delete"
      centered
    >
      <Modal.Header />
      <Modal.Body>
        <div
          style={{
            wordWrap: "break-word",
            padding: "22px",
            fontSize: "15px",
            textAlign: "center",
          }}
        >
          <img
            src={iconSrc}
            style={{ ...iconSize, marginBottom: isDelete ? "20px" : "10px" }}
            alt={isDelete ? "Delete" : "Deactivate"}
          />
          <h4 style={{ color: "#CC2229", fontSize: "20px" }}>
            {title || defaultTitle}
          </h4>
          <p>{message || defaultMessage}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="delete-modal-buttons">
        <Button className="btn-cancel outline-btn" variant="default" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="danger"
          className="btn-deactive"
          onClick={() => onConfirm(itemName)}
          disabled={loading}
          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
        >
          {loading && <CircularProgress size={14} thickness={5} sx={{ color: "#fff" }} />}
          {confirmText || defaultConfirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
